import { DropdownList } from '@components/dropdown-list'

customElements.define('kiss-dropdown-list', DropdownList)
